import React, {useState} from 'react';
import {ProjectIconCategory} from "../../../gd/const/item-icon/project-categories";
import {TaskIconCategory} from "../../../gd/const/item-icon/task-categories";
import {IconType} from "./@const";
import IconTab_Content from "./icon/icon";
import EmojiTab_Content from "./emoji/emoji";
import UrlTab_Content from "./url/url";
import {GoalsIconCategory} from "../../../gd/const/item-icon/goals-categories";
import IconSelectorTabs from "./top/icon-selector-tabs";

export type IconSelectorProps = {
    iconCategories  : ProjectIconCategory[] | TaskIconCategory[] | GoalsIconCategory[]
    iconTypes       : IconType[]
    icon            : string
    onChange        : callback
}

export default function IconSelector(props: IconSelectorProps) {

    const [iconTab, setIconTab] = useState<IconType>(gd.layout.activeTabBar || IconType.ITEM_ICONS)

    const onChangeTab = (iconTab: IconType)=> {
        gd.layout.activeTabBar = iconTab
        setIconTab(iconTab)
    }

    return (
        <div className="color-with-icon">
            <div className="ui5-popover-selector icon-selector-new p-t-0">

                {props.iconTypes.length > 1 && (
                    <IconSelectorTabs iconTypes={props.iconTypes} selectedTab={iconTab} onChangeTab={onChangeTab}/>
                )}

                {iconTab === IconType.ITEM_ICONS && props.iconTypes.includes(IconType.ITEM_ICONS) &&
                    <IconTab_Content {...props} />
                }

                {iconTab === IconType.EMOJI_ICONS && props.iconTypes.includes(IconType.EMOJI_ICONS) &&
                    <EmojiTab_Content {...props} />
                }

                {iconTab === IconType.URL && props.iconTypes.includes(IconType.URL) &&
                    <UrlTab_Content {...props} />
                }
            </div>
        </div>
    );
}
